import React from 'react';
import {
  CalendarTimeZoneUtil,
  DateUtil,
  Icon,
  Layout,
  LayoutItem,
  Paragraph,
} from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';
import moment from 'moment/moment';

export type EngagementsViewInterviewDetailsProps = {
  interview: CandidateEngagementDetails['interviews'][number];
  name?: string;
};
export const EngagementsViewInterviewDetails: React.FC<
  EngagementsViewInterviewDetailsProps
> = ({ interview, name = 'ENGAGEMENTS_VIEW_INTERVIEW_DETAILS' }) => {
  return (
    <Layout direction="vertical" name={name} verticalGutter="8px">
      <Layout horizontalGutter="8px" position="left top">
        <LayoutItem>
          <Icon name="calendar" />
        </LayoutItem>
        <LayoutItem hug>
          <Paragraph name="INTERVIEW_DETAILS_DATE">
            {interview.startTime
              ? `${DateUtil.displayLongDay(interview.startTime)}, ${DateUtil.displayLongMonthDayYear(interview.startTime)}`
              : '--'}
          </Paragraph>
        </LayoutItem>
      </Layout>
      <Layout horizontalGutter="8px" position="left top">
        <LayoutItem>
          <Icon name="clock" />
        </LayoutItem>
        <LayoutItem hug>
          <Paragraph name="INTERVIEW_DETAILS_TIME">
            {interview.startTime && interview.endTime
              ? `${DateUtil.displayFullTimeRange(
                  interview.startTime,
                  interview.endTime
                )} ${
                  CalendarTimeZoneUtil.getZoneFromMomentZone(
                    moment.tz(new Date(), moment.tz.guess())
                  )?.abbr ?? ''
                }`
              : '--'}
          </Paragraph>
        </LayoutItem>
      </Layout>
      <Layout horizontalGutter="8px" position="left top">
        <LayoutItem>
          <Icon name="avatar" />
        </LayoutItem>
        <LayoutItem hug>
          {interview.attendees.length > 0 ? (
            interview.attendees.map((attendee, index) => (
              <Paragraph
                key={attendee}
                name={`INTERVIEW_DETAILS_ATTENDEE_${index}`}
              >
                {attendee}
              </Paragraph>
            ))
          ) : (
            <Paragraph name="INTERVIEW_DETAILS_NO_ATTENDEES">--</Paragraph>
          )}
        </LayoutItem>
      </Layout>
      <Layout horizontalGutter="8px" position="left top">
        <LayoutItem>
          <Icon name="waypoint-filled" />
        </LayoutItem>
        <LayoutItem hug>
          <Paragraph
            name="INTERVIEW_DETAILS_ZOOM_LINK"
            className="max-lines-strict-1"
          >
            {interview.zoomLink ? (
              <a href={interview.zoomLink} target="_blank" rel="noreferrer">
                {interview.zoomLink}
              </a>
            ) : (
              'Join this meeting using the link in your calendar invite.'
            )}
          </Paragraph>
        </LayoutItem>
      </Layout>
    </Layout>
  );
};
